module.exports = __webpack_public_path__ + "static/img/8.3743ce4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/eng/8.png
// module id = OmPE
// module chunks = 0